import { Component, ElementRef, ViewChild } from '@angular/core';
import { PageBase } from 't4core';
import { T4DatatableWidget } from '../../../../t4common/';
import { T4_ServiceDialog } from '../../../Service/dialogs/serviceDialog/serviceDialog';


@Component({
  selector: 'StolenTrailers',
  styleUrls: ['./StolenTrailers.css'],
  templateUrl: './StolenTrailers.html',
})
export class StolenTableComponent extends PageBase {
  @ViewChild("tblActive", { static: false }) private tblActive: T4DatatableWidget;
  @ViewChild("tblRecentClosed", { static: false }) private tblRecentClosed: T4DatatableWidget;

  public isAdmin: boolean = false;

  constructor(el: ElementRef) {
    super(el, "StolenTable");
  }

  public showDetails(id: string) {
    this.Dialog.open(T4_ServiceDialog, { data: { requestId: id } }).afterClosed().toPromise().then((x: any) => {
      
    });
  }


}
